import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  tree: { data: [], list: [], loading: false },
  cate: { data: [], list: [], loading: false },
  label: { data: [], list: [], loading: false },
  colors: { data: [], loading: false },
  versions: { data: [], loading: false },
  pubTrees: { data: [], loading: false },
  verTrees: { data: [], loading: false },
  entityTypes: { data: [], loading: false },
  images: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false, params: null },
  dialog: { type: '', data: null, visible: false, loading: false },
  confirm: { type: '', data: null, visible: false, loading: false },
  expanded: { expand: false, tab: 0 },
  loaded: { type: '', loading: false },
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
